import { html } from "lit";

import { customElement } from "lit/decorators.js";

import { BaseSocialButton } from "ui-components/social-login-buttons";
import { appleLogoTemplate } from "ui-components/social-logos";

@customElement("apple-sign-up-button")
export class AppleSignUpButton extends BaseSocialButton {
  override render() {
    return html`${appleLogoTemplate}`;
  }
}
